module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("sitepage_cancellation", [["div",{"class":"site-page cancellation"},[["section",{"class":"about-wrapper","id":"account-form"},[["div",{"class":"title-block"},[["div",{"class":"page-width"},[["div",{"class":"title"},[["p",{},[["textNode",{"text":"Cancellation"}]]]]]]]]],["div",{"class":"content-page cancellation-page page-width"},[["div",{"class":"cite"}],["div",{"class":"cancellation-form-wrapper"}]]]]]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader?interpolate!./templates/sitepage/cancellation.tpl
// module id = 1080
// module chunks = 4